import React from "react"
import { InstagramAlt as Instagram } from "styled-icons/boxicons-logos/InstagramAlt"
import { Twitter } from "styled-icons/boxicons-logos/Twitter"
import { LinkedinIn as Linkedin } from "styled-icons/fa-brands/LinkedinIn"
import { Rocket } from "@styled-icons/ionicons-solid"
import { Close } from "styled-icons/evil/Close"

export default {
  icons: {
    Close,
  },
  links: [
    {
      key: "home",
      label: <span>Home</span>,
      insideHome: true,
      scrollTo: "section-home",
      offset: -170,
    },
    {
      key: "sobre",
      label: <span>Quem Somos</span>,
      insideHome: true,
      scrollTo: "caption-about",
      offset: -170,
    },
    {
      key: "servicos",
      label: <span>Serviços</span>,
      insideHome: true,
      scrollTo: "slider-servicos",
      offset: -140,
    },
    {
      key: "portfolio",
      label: <span>Portfólio</span>,
      insideHomeAndPage: true,
      scrollTo: "section-portfolio",
      routeTo: "/portfolio",
      offset: -40,
    },
    {
      key: "blog",
      label: <span>Blog</span>,
      insideHomeAndPage: true,
      scrollTo: "section-blog",
      routeTo: "/blog",
      offset: -150,
    },
    {
      key: "contato",
      label: (
        <span>
          Tenho uma ideia <Rocket />
        </span>
      ),
      scrollTo: "section-contato",
      insideHome: true,
      offset: -10,
      isButton: true,
    },
  ],

  social: [
    {
      label: "Instagram",
      key: "url_instagram",
      icon: Instagram,
    },

    {
      label: "Linkedin",
      key: "url_linkedin",
      icon: Linkedin,
    },
  ],
}
